import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * Inventory.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.name - Name of the contingent
 * @param {string} params.uuid - Unique identifier
 * @constructor
 */
export default class Inventory extends BaseAPIModel {
    /* DEPRECATED ACCESSORS */
    id() {
        return this.pk;
    }

    toString() {
        return this.name;
    }

    subinventories() {
        return this.object.sub_inventories || [];
    }

    hasSubinventories() {
        return this.subinventories().length;
    }

    isVirtual() {
        return this.object.virtual;
    }

    isSocialDistancing() {
        return this.object.social_distancing_x + this.object.social_distancing_y + this.object.social_distancing_z > 0;
    }

    // Naming with snake_case because there already is a method called subInventories
    set sub_inventories(inventories) {
        if (!this.object.virtual) {
            throw new Error('[Model][Inventory] Cannot add sub inventories to a non-virtual inventory');
        }

        this.object.sub_inventories = inventories;
    }

    get sub_inventories() {
        return this.object.sub_inventories;
    }

    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {},
            display_order: {}
        };
    }

    static listUrl({ organizationId, chartId, eventId, partnerId }) {
        if (!organizationId || !(chartId || partnerId || eventId)) {
            throw new ArgumentError(`[Model][Inventory][getAll] organizationId and (chartId or partnerId) are mandatory`);
        }

        if (partnerId) {
            return `/ticket/organizations/${organizationId}/partners/${partnerId}/availability/inventories`;
        }

        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/inventories`;
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/inventories`;
    }

    static forEvent({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][Inventory][getAll] organizationId and eventId are mandatory`);
        }

        let url = `/ticket/organizations/${organizationId}/events/${eventId}/inventories`;
        return fetcher.get(url).then(({ response }) => this.list(response));
    }
}

/**
 * HISTORIC
 * Create Inventory from API return
 * @param {Object[]} data - Data returned from API
 * @returns {Zone[]} List of new Zones
 */
Inventory.fromAPI = data => data.map(inventory => new Inventory(inventory));
